import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Colours(props: StickerArtProps) {
  return (
    <StickerFrame background="#475569" {...props}>
      <path
        d="M32 12 C18 12 10 22 10 32 C10 44 20 52 30 52 C34 52 35 49 33 46 C31 43 33 40 37 40 L44 40 C50 40 54 36 54 30 C54 19 44 12 32 12 Z"
        fill="#ffffff"
      />
      <circle cx="21" cy="27" r="4.5" fill="#ef4444" />
      <circle cx="32" cy="20" r="4.5" fill="#facc15" />
      <circle cx="43" cy="25" r="4.5" fill="#22c55e" />
      <circle cx="20" cy="39" r="4.5" fill="#3b82f6" />
    </StickerFrame>
  );
}
